import { BRAND_SVG } from './brand.gen';

export type BrandKind = keyof typeof BRAND_SVG;

/** The SVG markup of a logo, with the classes the prototypes give it (`xrBrand()`). */
export const brandSvg = (kind: BrandKind): string =>
  BRAND_SVG[kind].replace('<svg ', `<svg class="xr-${kind}" aria-hidden="true" focusable="false" `);

/**
 * The xReceived logo (needs css/brand.css). Same markup as the prototypes' `xrBrand(kind, { rev, h, cls })`,
 * so the CSS and the screenshots match. `rev` forces the reversed (cream) colours.
 */
export function Brand({ kind = 'lockup', rev, h, cls }: { kind?: BrandKind; rev?: boolean; h?: number; cls?: string }) {
  return (
    <span
      className={`xr-brand xr-brand-${kind}${rev ? ' rev' : ''}${cls ? ' ' + cls : ''}`}
      style={h ? { height: h + 'px' } : undefined}
      role="img"
      aria-label="xReceived"
      dangerouslySetInnerHTML={{ __html: brandSvg(kind) }}
    />
  );
}
